<svg width="60" height="41" viewBox="0 0 60 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30 4.13268L30 36.1327" stroke="#00A5AD" stroke-dasharray="2 2"/>
</svg>
